define( function() {
	return ( /^$|\/(?:java|ecma)script/i );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/var/rscriptType.js
 ** module id = 448
 ** module chunks = 2
 **/